export { TourWaves as default } from "./tour-waves";
